import axios from "axios";
import toast from "react-hot-toast";
import CustomRouter from "components/CustomBrowserRouter";
import Toast from "components/Toast";
import history from "components/history";
import React, { useEffect, useState } from "react";

import { Provider } from "react-redux";
import Routes from "routes";
import { FormProvider } from "./components/FormContext";
import store from "./store/store";
import ThemeProvider from "./theme";
import Cookie from "./utils/cookie";

// Configure axios defaults
axios.defaults.baseURL = `${process.env.REACT_APP_API_BASE_URL}/v2`;

// Add request interceptor to ensure token is included in every request
axios.interceptors.request.use(
  (config) => {
    const token = Cookie.get("jwt");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Cookie.delete("jwt");
      // Cookie.delete("user");
      // history.push("/login");
    }
    if (error.response && error.response.status === 403) {
      const message = error.response.data?.message;
      if (message) {
        toast.error(message);
      }
    }
    throw error;
  }
);

// DEPLOYED DATE 01/09/2023

function App() {
  const [jwtToken, setJwtToken] = useState(Cookie.get("jwt"));

  // Set up effect to update the Authorization header when JWT token changes
  useEffect(() => {
    // Update the Authorization header with the current JWT token
    axios.defaults.headers.common["Authorization"] = jwtToken
      ? `Bearer ${jwtToken}`
      : "";

    // Set up an interval to check for token changes
    const tokenCheckInterval = setInterval(() => {
      const currentToken = Cookie.get("jwt");
      if (currentToken !== jwtToken) {
        setJwtToken(currentToken);
      }
    }, 1000); // Check every second

    return () => clearInterval(tokenCheckInterval);
  }, [jwtToken]);

  return (
    <Provider store={store}>
      <ThemeProvider>
        <FormProvider>
          <React.Suspense fallback="">
            <CustomRouter history={history}>
              <Routes />
            </CustomRouter>
          </React.Suspense>
        </FormProvider>
        <Toast />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
